import { useQuery } from "@tanstack/react-query";
import TopBar from "@/components/top-bar";
import CourseCard, {
  CourseCardSkeleton,
} from "@/features/miniapp/components/course-card";
import LoginRequired from "@/components/login-required";
import { WishlistService } from "@/services/wishlist-service";
import { useProfileStore } from "@/store/profile-store";

const LIST_GRID = "grid w-full gap-3 p-4 md:grid-cols-2 lg:grid-cols-3";
const FULL_ROW = "md:col-span-2";

export default function WishlistPage() {
  const accessToken = useProfileStore((s) => s.tokens?.access_token);

  const { data, isPending, isError } = useQuery({
    queryKey: ["wishlist"],
    queryFn: async () => {
      const res = await WishlistService.getWishlist({
        perPage: 50,
      });
      return res.data ?? [];
    },
    enabled: Boolean(accessToken),
    staleTime: 1000 * 60,
  });

  const courses = data ?? [];

  return (
    <div className="bg-secondary-background min-h-svh">
      <TopBar title="علاقه‌مندی‌ها" />

      {!accessToken ? (
        <LoginRequired
          title="برای مشاهده علاقه‌مندی‌ها وارد شوید"
          description="پس از ورود، دوره‌هایی که به لیست علاقه‌مندی‌ها اضافه کرده‌اید اینجا نمایش داده می‌شوند."
        />
      ) : isPending ? (
        <div className={LIST_GRID}>
          {Array.from({ length: 4 }).map((_, i) => (
            <CourseCardSkeleton key={i} />
          ))}
        </div>
      ) : (
        <div className={LIST_GRID} data-track-section="wishlist_courses">
          {isError ? (
            <p className={`text-danger py-8 text-center text-sm ${FULL_ROW}`}>
              مشکلی در دریافت لیست علاقه‌مندی‌ها پیش آمد.
            </p>
          ) : courses.length === 0 ? (
            <div className={`text-default-600 py-8 text-center ${FULL_ROW}`}>
              لیست علاقه‌مندی‌های شما خالی است.
            </div>
          ) : (
            courses.map((course, index) => (
              <CourseCard
                key={course.id}
                slotIndex={index}
                title={course.title}
                sessionsCount={course.lessons_count}
                studentsCount={course.users_count}
                thumbnail={
                  course.vitrin_cover_url || course.cover_url || course.external_media?.media_token || ""
                }
                courseId={course.id}
                miniAppUuid={course.mini_app?.uuid}
                rating={course.ratings_avg}
                price={course.price}
                specialPrice={course.special_price}
                isFree={course.is_free}
              />
            ))
          )}
        </div>
      )}

      <div className="h-16" />
    </div>
  );
}
